module.exports = __webpack_public_path__ + "static/media/close-black-icon.c3152d95.svg";